import { render, staticRenderFns } from "./documentResponse.vue?vue&type=template&id=61518ec5&scoped=true"
import script from "./documentResponse.vue?vue&type=script&lang=js"
export * from "./documentResponse.vue?vue&type=script&lang=js"
import style0 from "./documentResponse.vue?vue&type=style&index=0&id=61518ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61518ec5",
  null
  
)

export default component.exports